export default __webpack_public_path__ + "static/media/11.20e04b95.svg";